import { getDep } from '@/services/general/general';
import { GROUPE, ENSEIGNE, POINT_VENTE } from '@/configurations/clientConf';

export default function getPdv(getters) {
  const pdv = [];
  getters.tiersAllInit.forEach(tiers1 => {
    if (tiers1.typologie === 'PointVente' || tiers1.typologie === 'Aucun') {
      pdv.push(tiers1);
    }
    tiers1.tiersEnfants.forEach(tiers2 => {
      if (tiers2.typologie === 'PointVente'
          && !getters.filter.enseigne.length) {
        pdv.push(tiers2);
      } else if (tiers2.typologie === 'PointVente'
        && getters.filter.enseigne.length
        && getters.filter.enseigne.map(item => item.value).includes(tiers1.id)) pdv.push(tiers2);
      tiers2.tiersEnfants.forEach(tiers3 => {
        if (tiers3.typologie === 'PointVente'
            && !getters.filter.enseigne.length) {
          pdv.push(tiers3);
        } else if (tiers3.typologie === 'PointVente'
          && getters.filter.enseigne.length
          && getters.filter.enseigne.map(item => item.value).includes(tiers2.id)) pdv.push(tiers3);
      });
    });
  });
  return pdv;
}

export function getPdvByTiersAllData(tiersAll) {
  if (!tiersAll.length) return [];
  const pdv = [];
  tiersAll.forEach((tiers1) => {
    if (tiers1.typologie === 'PointVente' || tiers1.typologie === 'Aucun') {
      pdv.push({
        ...tiers1,
        enseigne: null,
        groupe: null,
      });
    }
    tiers1.tiersEnfants.forEach((tiers2) => {
      if (tiers2.typologie === 'PointVente') {
        pdv.push({
          ...tiers2,
          enseigne: tiers1,
          groupe: null,
        });
      }
      tiers2.tiersEnfants.forEach((tiers3) => {
        if (tiers3.typologie === 'PointVente') {
          pdv.push({
            ...tiers3,
            enseigne: tiers2,
            groupe: tiers1,
          });
        }
      });
    });
  });
  return pdv.map((el) => ({
    id: el.id,
    coordonnees: {
      lat: el.adressePostale.latitude ? el.adressePostale.latitude : 0,
      lng: el.adressePostale.longitude ? el.adressePostale.longitude : 0,
    },
    chemin: el.chemin,
    nomCommercial: el.nomCommercial,
    adressePostale: el.adressePostale,
    tiersParentId: el.tiersParentId,
    nomEnseigne: el.enseigne ? el.enseigne.nomCommercial : '',
    nomGroupe: el.groupe ? el.groupe.nomCommercial : '',
    ville: el.adressePostale ? el.adressePostale.ville : '',
    departement: el.adressePostale ? getDep(el.adressePostale.codePostal) : '',
    typologie: el.typologie,
    selected: el.selected,
  }));
}

export function getAllPdvIdsTiers(tiers) {
  const ids = [];
  const getIdsTiers = (t) => {
    if (t.tiersEnfants?.length) t.tiersEnfants.forEach(getIdsTiers);
    else ids.push(t.id);
  };
  getIdsTiers(tiers);
  return ids;
}

export function getPdvIdsByDataSelected(tiersAll, dataTiersSelected) {
  const pdvIds = dataTiersSelected.tiersId || [];
  const groupeIds = dataTiersSelected.groupeIds || [];
  const enseigneIds = dataTiersSelected.enseigneIds || [];
  const getDataFunction = (tiers) => {
    if (tiers.typologie === GROUPE && groupeIds.includes(tiers.id)) {
      pdvIds.push(...tiers.tiersEnfants.flatMap(t2 => t2.tiersEnfants.map(t3 => t3.id)));
    }
    if (tiers.typologie === ENSEIGNE && enseigneIds.includes(tiers.id)) {
      pdvIds.push(...tiers.tiersEnfants.map(t2 => t2.id));
    }
    if (tiers?.tiersEnfants?.length) tiers.tiersEnfants.forEach(getDataFunction);
  };
  tiersAll.forEach(getDataFunction);
  return pdvIds;
}

export function getDataSelectedByPdvIds(tiersAll, pdvIds) {
  const groupeIds = [];
  const enseigneIds = [];
  const tiersId = [];
  const getDataFunction = (tiers) => {
    const {
      id,
      typologie,
      tiersEnfants,
      tiersParentId,
      tiersParentGroupeId,
    } = tiers;
    const isSelected = getAllPdvIdsTiers(tiers).every(id => pdvIds.includes(id));
    if (typologie === GROUPE && isSelected) {
      groupeIds.push(id);
    }
    if (typologie === ENSEIGNE && isSelected
      && !groupeIds.includes(tiersParentId)) {
      enseigneIds.push(id);
    }
    if (typologie === POINT_VENTE && isSelected
      && !groupeIds.includes(tiersParentGroupeId)
      && !enseigneIds.includes(tiersParentId)) {
      tiersId.push(id);
    }
    if (tiersEnfants?.length) tiersEnfants.forEach(getDataFunction);
  };
  tiersAll.forEach(getDataFunction);
  return { groupeIds, enseigneIds, tiersId };
}

export function getAscendingParentIds(tiers) {
  const parentIds = [];
  const func = (tiers) => {
    parentIds.push(tiers.id);
    if (tiers.tiersParent) func(tiers.tiersParent);
  };
  func(tiers);
  return parentIds;
}
